import React from 'react';
import { CodeTemplates } from './codeDocumentationTemplates';
import { WorkshopAppointmentForm } from '../components/panel/case/forms/workshopAppointment/workshopAppointmentForm';
import { DocumentationRequestForm } from '../components/panel/case/forms/documentation/DocumentationRequestForm';
import { InformationRequestForm } from '../components/panel/case/forms/information/InformationRequestForm';
import { TerminationsRequestForm } from '../components/panel/case/forms/terminations/TerminationsRequestForm';
import { SubstitutionVehicleRequestForm } from '../components/panel/case/forms/substitutionVehicle/SubstitutionVehicleRequestForm';
import { ClaimsRequestForm } from '../components/panel/case/forms/Claims/ClaimsRequestForm'
import { DeliveryRequestForm } from '../components/panel/case/forms/delivery/DeliveryRequestForm';
import { OvcForm } from '../components/panel/case/forms/ovc/OvcForm';
import { ItvForm } from '../components/panel/case/forms/itv/ItvForm';
import { FuelCardForm } from '../components/panel/case/forms/fuelCard/FuelCardForm';
import { MarshForm } from '../components/panel/case/forms/marsh/MarshForm';
import { LetterQueryForm } from '../components/panel/case/forms/letters/LetterQueryForm';
import { ResidentCardForm } from '../components/panel/case/forms/residentCard/ResidentCardForm';
import { DocumentationLettersForm } from '../components/panel/case/forms/documentation/DocumentationLettersForm';
import { TestForm } from '../components/panel/case/forms/S4F_TESTES/TestForm';
import { Test2Form } from '../components/panel/case/forms/S4F_TESTES/Test2Form';
import { PurchasesRequestForm } from '../components/panel/case/forms/S4F/PurchasesRequestForm';
import { FinancingRequestForm } from '../components/panel/case/forms/S4F/FinancingRequestForm';
import { InsuranceRequestForm } from '../components/panel/case/forms/S4F/InsuranceRequestForm';

export function CaseForms  (props) {
    const { classes,template,dataForm,setDataForm,setNames, dataFormAttachments, setDataFormAttachments} = props;

    function onChange (main,value) {
        setDataForm(prevState => ({...prevState, [main]: value}));
        setNames(prevState => (names));
    }
    function onChangeData(main,value) {
        setDataForm(main,value);
        setNames(prevState => (names));
    }
    function onChangeAttachments (files) {
        setDataFormAttachments(files);
        setNames(prevState => (names));
    }

    function onChangeAppointment (main,value) {
        setDataForm(main,value);
        setNames(prevState => (names));
    }
    
    function onChangeDocumentationRequest (main,value) {
        setDataForm(main,value);
        setNames(prevState => (names));
    }

    

    function onChangeInformationRequest (main,value) {
        setDataForm(main,value);
        setNames(prevState => (names));
    }

    function onChangeTerminationRequest (main,value) {
        setDataForm(main,value);
        setNames(prevState => (names));
    }
    function onChangeSubstitutionVehicleRequest (main,value) {
        setDataForm(main,value);
        setNames(prevState => (names));
    }

    function onChangeClaimRequest(main,value){
        setDataForm(main, value);
        setNames(prevState => (names));
    }

    function onChangeDeliveryRequest(main,value){
        setDataForm(main, value);
        setNames(prevState => (names));
    }
    function onChangeOvcRequest (main,value) {
        setDataForm(main,value);
        setNames(prevState => (names));
    }
    function onChangeItvRequest (main,value) {
        setDataForm(main,value);
        setNames(prevState => (names));
    }
    function onChangeFuelCardRequest (main,value) {
        setDataForm(main,value);
        setNames(prevState => (names));
    }

    function onChangeMarshRequest (main,value) {
        setDataForm(main,value);
        setNames(prevState => (names));
    }

    function onChangeLetterQuery(main,value) {
        setDataForm(main,value);
        setNames(prevState => (names));
    }

    let templateCode = template == null ? '' :template.code;
    let form = <div></div>;
    let names = [];

    switch (templateCode) {
        case CodeTemplates.WORKSHOP_APPOINTMENT:
            form= <WorkshopAppointmentForm classes={classes} dataForm={dataForm} onChange={onChangeAppointment}/>
            break;
        case CodeTemplates.DOCUMENTATION_REQUEST:
            form= <DocumentationRequestForm classes={classes} dataForm={dataForm} onChange={onChangeDocumentationRequest}/>
            break;
        case CodeTemplates.FACTORY_PROCESS_VEHICLE_DELIVERY:
            form = <DeliveryRequestForm classes={classes} dataForm={dataForm} onChange={onChangeDeliveryRequest} template={template} />
            break;
        case CodeTemplates.FACTORY_PROCESS_CLAIMS:
            form = <ClaimsRequestForm classes={classes} dataForm={dataForm} onChange={onChangeClaimRequest} template={template} />
            break;
        case CodeTemplates.INFORMATION:
            form= <InformationRequestForm classes={classes} dataForm={dataForm} onChange={onChangeInformationRequest} template={template} />
            break;
        case CodeTemplates.TERMINATIONS:
            form= <TerminationsRequestForm classes={classes} dataForm={dataForm} onChange={onChangeTerminationRequest} template={template} />
            break;
        case CodeTemplates.SUBSTITUTION_VEHICLE:
            form= <SubstitutionVehicleRequestForm classes={classes} dataForm={dataForm} onChange={onChangeSubstitutionVehicleRequest} template={template} />
            break;
        case CodeTemplates.OVC:
            form = <OvcForm classes={classes} dataForm={dataForm} onChange={onChangeOvcRequest} template={template}/>
            break;
        case CodeTemplates.FAILED_ITV:
                form = <ItvForm classes={classes} dataForm={dataForm} onChange={onChangeItvRequest} template={template}/>
            break;
        case CodeTemplates.FUEL_CARD:
                form = <FuelCardForm classes={classes} dataForm={dataForm} onChange={onChangeFuelCardRequest} template={template}/>
            break;
        case CodeTemplates.MARSH_ASSISTANCE:
            form = <MarshForm classes={classes} dataForm={dataForm} onChange={onChangeMarshRequest} template={template}/>
            break;
        case CodeTemplates.LETTER_QUERY:
            form = <LetterQueryForm classes={classes} dataForm={dataForm} onChange={onChangeLetterQuery} template={template}/>
            break;
        case CodeTemplates.RESIDENT_CARD_LETTER:
            form = <ResidentCardForm classes={classes} dataForm={dataForm} onChange={onChangeDocumentationRequest} template={template}/>
            break;
        case CodeTemplates.TESTE_1:
            form = <TestForm templateCode={templateCode} classes={classes} dataForm={dataForm} onChange={onChange} template={template} setNames={setNames}/>
            break;
        case CodeTemplates.TESTE_2:
            form= <Test2Form classes={classes} dataForm={dataForm} onChange={onChangeData} onChangeAttachments={onChangeAttachments}/>
            break;
        case CodeTemplates.PURCHASES:
            form= <PurchasesRequestForm classes={classes} dataForm={dataForm} onChange={onChangeData} onChangeAttachments={onChangeAttachments} template={template}/>
            break;
        case CodeTemplates.FINANCING:
            form= <FinancingRequestForm classes={classes} dataForm={dataForm} onChange={onChangeData} onChangeAttachments={onChangeAttachments} template={template}/>
            break;
        case CodeTemplates.INSURANCE:
            form= <InsuranceRequestForm classes={classes} dataForm={dataForm} onChange={onChangeData} onChangeAttachments={onChangeAttachments} template={template}/>
            break;
        default:
            form= <DocumentationLettersForm templateCode={templateCode} classes={classes} dataForm={dataForm} onChange={onChange} template={template} setNames={setNames}/>
    }

    return (form);
}